import { Component, Input, Output, EventEmitter } from "@angular/core";
import { SelectItem } from "primeng/primeng";
import { BaseStepComponent } from "../../../base/base-step.component";
import { ValidarData } from '../../../util/custom.validators';

@Component({
    selector: 'gerenciamento-curso-etapa2',
    templateUrl: './gerenciamento-curso-etapa2.component.html',
})
export class CrudGerenciamentoCursoEtapa2Component extends BaseStepComponent {
  @Input() listaResumo: any[] = [];
  @Input() listaRelatores: any[];
  @Input() listaTurma: any[] = [];
  @Output() listaTurmaChange = new EventEmitter<any>();
  @Input() validateForm: any = false;
  @Output() validateFormChange = new EventEmitter<any>();
  @Input() listaUf: SelectItem[] = [];
  @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);
  @Input() listaDiasSemana: any[] = [];
  @Input() listaPais: SelectItem[] = [];
  @Input() listaMunicipios: SelectItem[] = [];
  requiredValidator: boolean = false;
  @Input() hoje = new Date();
  listaCidades: SelectItem[] = [];
  @Input() isGestorCFC: any;

  
  readonly BRASIL = 31;
  dataMinima = new Date();
  isEditing: boolean = false;

  init() {
    this.dataMinima.setDate(this.dataMinima.getDate() + 5);

    this.stepObject.emit(this);

        this.emitValidation(true);

        this.cadastro.get('id_uf').valueChanges.subscribe(id_uf => {
            this.service.ListarTodos('cidade', { id_estado: id_uf }).subscribe(data => {
                this.listaCidades = data;
            })
        });
        this.cadastro.get('id_pais').valueChanges.subscribe(id => {
            this.requiredValidator = id === 31 ? true : false
        });

        this.cadastro.get('turma_titulo').valueChanges.subscribe(nome => {
            if (this.cadastro.get('turma_titulo') && nome) {
                const turma = nome.replace(/\s{2,}/g, ' ');
                this.cadastro.get('turma_titulo').setValue(turma.trim());
            }
        });

        if (this.acao === 'abrir-recurso') {
            this.cadastro.enable();
        }        

        if (this.gestorCfc) {
            this.hoje = new Date();
            this.cadastro.get('data_inicio').setValue('');
            this.cadastro.get('data_fim').setValue('');
        }


        this.observableUser.getValue.subscribe(data => {
            if (data && data != "") {
                if (data.obj.lotacaoDTO.find(y => y.id == localStorage.getItem('lotacao')).sigla == 'CFC' 
                    && data.obj.lotacaoDTO.find(y => y.id == localStorage.getItem('lotacao'))
                    .perfilDTO.filter(x => x.nome == 'Gestor CFC')
                    .length > 0) {
                    this.isGestorCFC = true;
                    this.hoje = new Date();
                }
                else {
                    this.isGestorCFC = false;
                }
            }
        });
    }

    emitValidation(isInit = false) {
        if (isInit) {
            this.validateForm = [];
        } else {
            if (this.listaTurma.length > 0) {
                this.isValid = true;
            } else {
                this.isValid = false;
                this.validateForm = [this.cadastro];
                super.showMsg('warn', 'Turma', 'É necessário informar ao menos uma Turma');
            }
        }
        setTimeout(() => this.validateFormChange.emit(this.validateForm), 0);
        this.isValidChange.emit(this.isValid);
    }

    salvarListaTurma(event) {
        let inicio = new Date(this.cadastro.get('data_inicio').value);
        let final = new Date(this.cadastro.get('data_fim').value);
        
        this.isEditing = false;
        this.cadastro.get('data_inicio').enable();
        this.cadastro.get('data_fim').enable();
        if (!ValidarData(inicio, final)) {
            super.showMsg('warn', 'Turma', 'A data fim não pode ser menor que a data de início da turma.');
            return;
        }

        const retorno = this.addToList(this.listaTurma, this.listaTurmaChange,
            this.cadastro, event, { turma_titulo: this.cadastro.get('turma_titulo').value });
        if (retorno != false) {
            this.listaTurma = this.listaTurma.map(item => {
                if (item.id === null) {
                    if (item.turma_dia_semana.list != undefined) {
                        item.turma_dia_semana = item.turma_dia_semana.list.map(item => {
                            var valor = { id: null, id_turma: null, id_dia_semana: item }
                            return valor;

                        })
                    }
                    return item;
                }
            });
        }
        
    }


    editarEdicao(index: number) {
        const itemEdicao = this.listaTurma[index];
        const dataInicio = new Date(itemEdicao['data_inicio']);
        const dataFim = new Date(itemEdicao['data_fim']);

        if (!this.areValidDates(dataInicio, dataFim)) {
            this.showWarningMessage('Datas inválidas fornecidas.');
            return;
        }

        this.isEditing = true;
        this.cadastro.get('data_inicio').disable();
        this.cadastro.get('data_fim').disable();

        this.processEditEdicao(index, itemEdicao, dataInicio, dataFim);
    }

    processEditEdicao(index: number, itemEdicao: any, dataInicio: Date, dataFim: Date) {
        this.setDateHoursToZero(dataInicio, dataFim);

        if (dataFim < dataInicio) {
            this.showWarningMessage('A data fim não pode ser menor que a data de início do evento.');
            return;
        }

        this.listaTurma.splice(index, 1);
        this.listaTurma = [...this.listaTurma];
        this.updateForm(itemEdicao);
        this.listaTurmaChange.emit(this.listaTurma);
    }

    setDateHoursToZero(...dates: Date[]) {
        dates.forEach(date => date.setHours(0, 0, 0, 0));
    }

    areValidDates(...dates: any[]): boolean {
        return dates.every(this.isValidDate);
    }

    isValidDate(date: any): boolean {
        return !isNaN(Date.parse(date));
    }

    updateForm(item: any) {
        const idDiaSemanaList = item.turma_dia_semana.map(
            item => item.id_dia_semana
        );
        this.cadastro.patchValue({
            turma_dia_semana: {
                list: idDiaSemanaList
            },
            data_inicio: new Date(item.data_inicio),
            data_fim: new Date(item.data_fim),
            id_pais: item.id_pais,
            turma_titulo: item.turma_titulo,
        }, {emitEvent: false});

        this.cadastro.get('id_pais').updateValueAndValidity();

        if (item.id_pais === this.BRASIL) {
            this.cadastro.patchValue({
                id_uf: item.id_uf,
                id_cidade: item.id_cidade
            }, {emitEvent: false});
            this.cadastro.get('id_uf').updateValueAndValidity();
            this.cadastro.get('id_cidade').updateValueAndValidity();
        }
    }

    showWarningMessage(message: string) {
        super.showMsg('warn', 'Edição', message);
    }
}


// WEBPACK FOOTER //
// ./src/app/gerenciamento-curso/crud/etapas/gerenciamento-curso-etapa2.component.ts